import api from '../config/api';
import { API_URLS } from '../config/urls';

export const policyService = {
    getTermsAndConditions: async () => {
        const response = await api.get(API_URLS.TERMS_AND_CONDITIONS);
        return response.data;
    },
    getCancellationPolicy: async () => {
        const response = await api.get(API_URLS.CANCELLATION_POLICY);
        return response.data;
    },
    getPrivacyPolicy: async () => {
        const response = await api.get(API_URLS.PRIVACY_POLICY);
        return response.data;
    },
};
